import { QueryFunctionContext } from '@tanstack/react-query'
import { WesService } from 'shared/services/WesService'
import type { GalleryContentQuery } from 'shared/types/gallery/content-query'
import type { DTT } from 'shared/types/vp/dtt'

export const QUERY_KEY = 'favoritesByProductKey'

export const queryFavorites = (
  context: QueryFunctionContext<DTT.Queries.WorkEntityService.ByProductKeyQueryKey>,
): Promise<DTT.Models.WorkEntityService.WorkEntity<GalleryContentQuery.PreviewInfo>[]> => {
  const { queryKey } = context
  const [_, { locale, wesTenant, ownerId, authorizationHeader, productKey }] = queryKey

  return WesService.getAllFavorites(locale, wesTenant, ownerId, authorizationHeader, productKey)
}
